import { useSearchParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Seo } from '@/components/Seo';
import { Container } from '@/components/ui/Container';
import { PageHeader } from '@/components/ui/PageHeader';
import { RoomBooking } from './RoomBooking';

export function RoomBookingPage() {
  const [params] = useSearchParams();
  const room = params.get('room') || undefined;
  return (
    <>
      <Seo title="Book a room" description="Book a room at Grace Haven BnB in Gaborone — choose your dates and request to book." />
      <PageHeader eyebrow="Grace Haven BnB" title="Book a room" intro="Choose your room and dates. We'll confirm availability by email — no payment is taken now." />
      <section className="bg-cream py-16">
        <Container>
          <Link to="/stay" className="inline-flex items-center gap-1.5 font-body text-sm font-medium text-gold-deep transition hover:text-espresso">
            <ArrowLeft size={15} /> Back to rooms
          </Link>
          <RoomBooking initialRoomId={room} />
        </Container>
      </section>
    </>
  );
}
